import Styled from 'styled-components'


export const Container = Styled.div`
`

export const ContainerContent = Styled.div`
`


export const Details = Styled.h2`
`

export const LogoVoo = Styled.div`
`

export const DataContainer = Styled.div`

`

export const Duration = Styled.p`
`

export const Line = Styled.div`
`

export const DivParagraphRight = Styled.div`
`

export const DivParagraphLeft = Styled.div`
`
export const Bar = Styled.div`
`